export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_catalogs(state, data) {
    state.catalogs = data;
    state.totalCount = data.totalCount;
    state.count = data.count;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
